import React, { ReactElement } from 'react';
import { ResetPasswordForm } from '../organisms';
import CardHeader from '../organisms/CardHeader';

export default function ResetPassword(): ReactElement {
  return (
    <div className="h-100">
      <div className="d-flex align-items-center h-100">
        <div className="mx-auto login-box">
          <div className="card">
            <CardHeader />
            <div className="card-body">
              <h2 className="card-title text-center py-1">
                Inserisci il codice ricevuto nella email ed una nuova password
              </h2>
              <ResetPasswordForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
